import React from 'react';
import { FiCheckCircle, FiAlertCircle, FiXCircle } from 'react-icons/fi';

const STATUS_CONFIG = {
  active: {
    label: 'Active',
    icon: FiCheckCircle,
    className: 'bg-green-100 text-green-800',
  },
  inactive: {
    label: 'Inactive',
    icon: FiAlertCircle,
    className: 'bg-yellow-100 text-yellow-800',
  },
  blocked: {
    label: 'Blocked',
    icon: FiXCircle,
    className: 'bg-red-100 text-red-800',
  },
};

/**
 * Displays user account status (active / inactive / blocked) as a badge.
 */
const UserStatusBadge = ({ status }) => {
  const config = STATUS_CONFIG[status] || {
    label: 'Unknown',
    icon: null,
    className: 'bg-gray-100 text-gray-800',
  };
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.className}`}
    >
      {Icon && <Icon className="w-3 h-3 mr-1" />}
      {config.label}
    </span>
  );
};

export default UserStatusBadge;
